import React from 'react';
import styles from "./ReferralBanner.module.css"
import { observer } from "mobx-react-lite";
import UserStore from "../../../store/user-store";
import { useNavigate } from "react-router-dom";

export const ReferralBanner = observer(() => {
    const navigate = useNavigate();
    return (
        <div className={styles.referralBanner}>
            {/* NEW badge */}
            <div className={styles.newBadge}>
                {UserStore.langCode === 'ru' ? "НОВОЕ" : "NEW"}
            </div>
            
            {/* Animated background elements */}
        
            {/* Main content */}
            <div className={styles.content}>
                <div className={styles.text}>
                    <h1>{UserStore.langCode === 'ru' ? "Реферальная программа" : "Referral Program"}</h1>
                    <p>{UserStore.langCode === 'ru' ? "Приглашайте друзей и зарабатывайте до 15% комиссии" : "Invite friends and earn up to 15% commission"}</p>
                </div>
                
                <button 
                    className={styles.joinButton}
                    onClick={() => navigate('/referrals')}
                >
                    {UserStore.langCode === 'ru' ? "Пригласить друга" : "Invite a friend"}
                </button>
            </div>
            
            {/* Decorative elements */}
            {/* <div className={styles.decorativeElements}>
                <div className={styles.gradientOrb1}></div>
                <div className={styles.gradientOrb2}></div>
            </div> */}
        </div>
    )
}) 